import React from 'react';
import {
  Box, Card, CardContent, Typography, Table, TableBody, TableCell,
  TableContainer, TableHead, TableRow, Paper, Grid
} from '@mui/material';
import { Business } from '@mui/icons-material';
import { fDateDdMmmYyyy } from '../../utils/time';

const AdminDashboard = ({ tenants }) => (
  <Box>
    <Typography variant="h5" fontWeight={600} mb={3}>Dashboard</Typography>
    <Grid container spacing={3}>
      <Grid item xs={12} sm={6} md={4}>
        <Card>
          <CardContent>
            <Box display="flex" alignItems="center" gap={2}>
              <Business color="primary" sx={{ fontSize: 40 }} />
              <Box>
                <Typography variant="body2" color="text.secondary">Total Schools</Typography>
                <Typography variant="h4" fontWeight={700}>{tenants.length}</Typography>
              </Box>
            </Box>
          </CardContent>
        </Card>
      </Grid>
      <Grid item xs={12} sm={6} md={4}>
        <Card>
          <CardContent>
            <Box display="flex" alignItems="center" gap={2}>
              <Business color="success" sx={{ fontSize: 40 }} />
              <Box>
                <Typography variant="body2" color="text.secondary">Recent (30 days)</Typography>
                <Typography variant="h4" fontWeight={700}>
                  {tenants.filter(t => {
                    const created = new Date(t.created_at);
                    return (Date.now() - created.getTime()) < 30 * 24 * 60 * 60 * 1000;
                  }).length}
                </Typography>
              </Box>
            </Box>
          </CardContent>
        </Card>
      </Grid>
    </Grid>

    <Typography variant="h6" mt={4} mb={2}>Recently Registered Schools</Typography>
    <Card>
      <TableContainer component={Paper} elevation={0}>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>School Name</TableCell>
              <TableCell>School ID</TableCell>
              <TableCell>Admin Email</TableCell>
              <TableCell>Created</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {[...tenants].sort((a, b) => new Date(b.created_at) - new Date(a.created_at)).slice(0, 5).map((t) => (
              <TableRow key={t.id} hover>
                <TableCell>{t.data?.school_name || '—'}</TableCell>
                <TableCell>{t.tenant_code || '—'}</TableCell>
                <TableCell>{t.data?.admin_email || '—'}</TableCell>
                <TableCell>{t.created_at ? fDateDdMmmYyyy(t.created_at) : '—'}</TableCell>
              </TableRow>
            ))}
            {tenants.length === 0 && (
              <TableRow><TableCell colSpan={4} align="center" sx={{ py: 3 }}>No tenants yet</TableCell></TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Card>
  </Box>
);

export default AdminDashboard;
